import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const arrow = new URL("../assets/images/arrow-dark.svg", import.meta.url);

export default function FooterText() {
  const [isClosed, setClosed] = useState(false);
  const [fullHeight, setFullHeight] = useState();
  const [closeHeight, setCloseHeight] = useState();
  const ref = useRef();

  useLayoutEffect(() => {
    const tm = setTimeout(() => {
      setFullHeight(ref.current.clientHeight);
      setCloseHeight(100);
      setClosed(true);
    }, 50);

    return () => clearTimeout(tm);
  }, []);

  const getHeight = () => {
    if (isClosed) {
      return closeHeight;
    }
    return fullHeight;
  };

  const toggleExpand = () => {
    setClosed(!isClosed);
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 500);
  };

  return (
    <>
      <div
        ref={ref}
        className="flex flex-col items-center text-[13px] font-interlight overflow-hidden transition-all relative duration-500"
        style={{ height: `${getHeight()}px` }}
        onClick={toggleExpand}
      >
        Sedan 2014 har vi på Fenix erbjudit familjer sinnesro i livets alla
        faser. Som trygg och kunnig begravningsbyrå underlättar vi planeringen i
        en svår stund. Med oss har du full transparens när det kommer till
        kostnader i stort som smått, från den noggrant utvalda gravstenen till
        det smakfulla blomsterarrangemanget. Vi finns här för dig genom varje
        steg för ett värdigt och personligt avsked. Utöver det finns vi även vid
        din sida med juridisk rådgivning i livets avgörande ögonblick. Vi bistår
        i såväl glädje som sorg, i alla tillfällen av allvar och förändring. Vi
        hjälper dig med allt från samboavtal, äktenskapsförord och testamente
        till bouppteckning och arvskifte.
        {isClosed && (
          <div className="absolute bottom-0 bg-gradient-to-b from-transparent to-white w-full h-[100px]"></div>
        )}
      </div>
      <div
        className="uppercase text-center tracking-[4px] text-[13px] flex items-center justify-center gap-2 mt-2"
        onClick={toggleExpand}
      >
        <div>Läs mer om oss</div>
        <img
          src={arrow}
          width={8}
          className={`transition ${isClosed ? "rotate-90" : "-rotate-90"}`}
        />
      </div>
    </>
  );
}
